// Encode current sprite pixels (8x8 or 16x16) into a simple hex format
// Each pixel is a single hex nibble (0..f). Rows are concatenated with newlines.
// This matches PICO-8 __gfx encoding style and is a good baseline for paste trials.
export function encodeSpriteToHex(pixels: number[][]): string {
  const h = pixels.length;
  const w = pixels[0]?.length || h;
  const clampHex = (v: number) => (v & 15).toString(16).toUpperCase();
  const lines: string[] = [];
  for (let y = 0; y < h; y++) {
    let row = '';
    for (let x = 0; x < w; x++) row += clampHex(pixels[y][x] || 0);
    lines.push(row);
  }
  return lines.join('\n');
}

// Future: If needed, implement the exact Pico-8 clipboard format here once confirmed.
export function encodeExperimentalPico8Clipboard(pixels: number[][]): string {
  // Placeholder: same as hex for now
  return encodeSpriteToHex(pixels);
}

// Encode sprite for Pico-8 clipboard as [gfx]...[/gfx]
// Pico-8 copies sprites to clipboard wrapped in [gfx] tags with a flat hex stream.
// Example from Pico-8: [gfx]08080009...[/gfx]
export function encodePico8GfxClipboard(pixels: number[][]): string {
  const h = pixels.length;
  const w = pixels[0]?.length || h;
  const clampHex = (v: number) => (v & 15).toString(16).toUpperCase();
  let hex = '';
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) hex += clampHex(pixels[y][x] || 0);
  }
  // Pico-8 clipboard prefix: two bytes width+height as hex (e.g. 0808 for 8x8, 1010 for 16x16)
  const wHex = Math.max(0, w).toString(16).toUpperCase().padStart(2, '0');
  const hHex = Math.max(0, h).toString(16).toUpperCase().padStart(2, '0');
  return `[gfx]${wHex}${hHex}${hex}[/gfx]`;
}
